export default {
  async getThumbnailAsync() {
    throw new Error('ExpoVideoThumbnails not supported on Expo Web');
  },
};
